import styled from 'styled-components'

export const BioCardHolder = styled.div`
  display: flex;
  flex-direction: column;
  width: 282px;
  height: 436px;
  margin-bottom: 32px;

  ${props => props.theme.breakpoints.down('md')} {
    width: 222px;
    height: 387px;
  }

  ${props => props.theme.breakpoints.down('sm')} {
    width: 360px;
    height: 522px;
  }

  ${props => props.theme.breakpoints.down('xs')} {
    width: 328px;
    height: 485px;
  }

  ${({ hasMiniBio, theme }: any) =>
    hasMiniBio
      ? `
    ${theme.breakpoints.up('sm')} {
      .BioCardWrapper {
        cursor: pointer;
        &:hover {
          .BioCardContent-FullName-Label {
            color: ${theme.webMktPalette.text.actionLight};
          }
          img {
            filter: brightness(85%);
          }
          .BioCardQuote-Block {
            background: ${theme.webMktPalette.background.black};
            &::before {
              width: 16px;
              height: 16px;
              top: 12px;
              left: 12px;
              background-image: url('https://images.ctfassets.net/5965pury2lcm/6fBlZ8oEF9bKZlt4rGEfEJ/9cb472e57a34bf56edf510836cc93816/ArrowSmall2X_Right.svg');
            }
          }
        }
      }
    }
    `
      : ``}
`

export const BioCardWrapper = styled.div`
  width: 100%;
  height: 100%;
`

export const BioCardImage = styled.div`
  position: relative;
  width: 282px;
  height: 324px;
  img {
    width: 100%;
    height: 100%;
  }

  ${props => props.theme.breakpoints.down('md')} {
    width: 222px;
    height: 255px;
  }

  ${props => props.theme.breakpoints.down('sm')} {
    width: 360px;
    height: 414px;
  }

  ${props => props.theme.breakpoints.down('xs')} {
    width: 328px;
    height: 377px;
  }
`

export const BioCardQuote = styled.div`
  position: absolute;
  width: 40px;
  height: 40px;
  top: 284px;
  left: 242px;
  background: ${props => props.theme.webMktPalette.background.white};
  &::before {
    content: '';
    position: absolute;
    width: 16px;
    height: 16px;
    top: 12px;
    left: 12px;
    background-image: url('https://images.ctfassets.net/5965pury2lcm/3DSiH3KemoK973VzfW2HbX/7169c608578292d26579a137ce224b60/Quote.svg');
  }

  ${props => props.theme.breakpoints.down('md')} {
    top: 215px;
    left: 182px;
  }

  ${props => props.theme.breakpoints.down('sm')} {
    top: 374px;
    left: 320px;
  }

  ${props => props.theme.breakpoints.down('xs')} {
    top: 337px;
    left: 288px;
  }
`

export const BioCardContent = styled.div`
  &.BioCardContent-FullName {
    margin-top: 24px;
  }
  &.BioCardContent-Role {
    margin-top: 8px;
  }

  ${props => props.theme.breakpoints.down('md')} {
    &.BioCardContent-Role {
      min-height: 48px;
    }
  }

  ${props => props.theme.breakpoints.down('sm')} {
    &.BioCardContent-Role {
      min-height: unset;
    }
  }
`

export const BioCardFooter = styled.div`
  display: flex;
  margin-top: 4px;
  flex-direction: row;

  ${props => props.theme.breakpoints.down('sm')} {
    margin-top: 1px;
  }
`

export const SocialMediaItem = styled.div`
  position: relative;
  width: 24px;
  height: 24px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  &.BioCardFooter-TwitterProfile {
    top: 2px;
    left: 2px;
    margin-right: 16px;
    background-image: url('https://images.ctfassets.net/5965pury2lcm/4dAYUTsXPrkP1BNdPSFmSp/c65e9a1d6fedea138b5c79ae4cb9a26f/Twitter24x24.svg');
  }
  &.BioCardFooter-LinkedInProfile {
    margin-left: 2px;
    background-image: url('https://images.ctfassets.net/5965pury2lcm/229hKtHNHuk5CtK8CJLnh/2ae651f3bb0995f2ced37f008ac619b5/Linkedin16x16.svg');
  }
  ${props => props.theme.breakpoints.up('sm')} {
    &:hover {
      &.BioCardFooter-TwitterProfile {
        background-image: url('https://images.ctfassets.net/5965pury2lcm/1GjxGoTBTRRFpxevacnau6/4eeda6e6ee80bd43f4fb309d6cf4ef61/Twitter_Icon_Hover.svg');
      }
      &.BioCardFooter-LinkedInProfile {
        background-image: url('https://images.ctfassets.net/5965pury2lcm/48rlfbSTKg2uv9RQesJX1w/49c4630153c0416ef365f06be3736263/LinkedIn_Icon_Hover.svg');
      }
    }
  }
`
